module.exports = __webpack_public_path__ + "static/media/blocked-access.8b64cabf.svg";